import type { Tab } from '../../custom-tab-bar/type.d.ts';

import { reportTypes } from './lib.ts';

export const route = {
  component: () => import('./page.vue'),
  path: '/reports',
  alias: ['/arrhythmia/history', '/records'],
  name: 'arrhythmia-history',
  meta: {
    title: '报告',
    titleMaps: reportTypes,
    titleKey: 'reportType',
    auth: true,
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'description-o',
  to: {
    name: route.name,
  },
};
